export const ActionWiseAPIConfiguration = {
  LOGIN: {
    url: "authenticationServiceAPI/AUTH/LOGIN",
    packageName: "",
  },
  VERIFYOTP: {
    url: "authenticationServiceAPI/POSTLOGIN/VERIFYOTP",
    packageName: "",
  },
  ADMINPANELUSERACTIVITY: {
    url: "commonServiceAPI/GETDYNAMICDATA/ADMINPANELUSERACTIVITY",
    packageName: "",
  },
  GETEMPLOYEEDTL: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETEMPLOYEEDTL",
    packageName: "",
  },
  DOUPDATEPASSWORD: {
    url: "userRegistrationServiceAPI/DOUPDATEPASSWORD",
    packageName: "",
  },
  UPDATEPROFILEPIC: {
    url: "configurationServiceAPI/UPDATEPROFILEPIC",
    packageName: "",
  },
  LOGOUTADMIN: {
    url: "commonServiceAPI/LOGOUTADMIN",
    packageName: "",
  },
  GETMENULIST: {
    url: "commonServiceAPI/GETMENULIST",
    packageName: "",
  },
  GETMISCVALUE: {
    url: "commonServiceAPI/GETMISCVALUE",
    packageName: "",
  },
  GETDASHBOARDDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETDASHBOARDDATA",
    packageName: "",
  },
  GETTRAFFICCHARTDASH: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETTRAFFICCHARTDASH",
    packageName: "",
  },
  GETTRANCHARTDATADASH: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETTRANCHARTDATADASH",
    packageName: "",
  },
  MESSAGEVALIDATION: {
    url: "configurationServiceAPI/GETVALIDATIONMESSAGEGRID",
    packageName: "",
  },
  BLOCKUSERS_AFTER: {
    url: "commonServiceAPI/GETDYNAMICDATA/BLOCKUSERS_AFTER",
    packageName: "",
  },
  BLOCKUSERS_PGW: {
    url: "commonServiceAPI/GETDYNAMICDATA/BLOCKUSERS_PGW",
    packageName: "",
  },
  BLOCKUSERS_BEFORE: {
    url: "commonServiceAPI/GETDYNAMICDATA/BLOCKUSERS_BEFORE",
    packageName: "",
  },
  USERRELEASE: {
    url: "commonServiceAPI/technicalSupport/USERRELEASE",
    packageName: "",
  },
  PGWUSERRELEASE: {
    url: "commonServiceAPI/technicalSupport/PGWUSERRELEASE",
    packageName: "",
  },
  GETAPPREVDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETAPPREVDATA",
    packageName: "",
  },

  USERSLIMITCONFGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/USERSLIMITCONFGRID",
    packageName: "",
  },
  GETCUSTACTIVEPENDINGGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETCUSTACTIVEPENDINGGRID",
    packageName: "",
  },
  GETPWDRESETPENDINGGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETPWDRESETPENDINGGRID",
    packageName: "",
  },
  GETCUSTACCTDTL: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETCUSTACCTDTL",
    packageName: "",
  },
  UPDATEPASSRESET: {
    url: "operationServiceAPI/UPDATEPASSRESET",
    packageName: "",
  },
  GETCUSTREGISTERREQ: {
    url: "operationServiceAPI/GETCUSTREGISTERREQ",
    packageName: "",
  },
  CUSTREGREQVERIFY: {
    url: "operationServiceAPI/CUSTREGREQVERIFY",
    packageName: "",
  },
  GETALLACCOUNTKEYS: {
    url: "operationServiceAPI/GETALLACCOUNTKEYS",
    packageName: "",
  },
  CUSTREGREQ: {
    url: "operationServiceAPI/CUSTREGREQ",
    packageName: "",
  },
  CUSTOMERSEARCH: {
    url: "operationServiceAPI/CUSTOMERSEARCH",
    packageName: "",
  },
  RESTUNLOCKUSER: {
    url: "operationServiceAPI/RESTUNLOCKUSER",
    packageName: "",
  },
  PASSWORDRESET: {
    url: "operationServiceAPI/PASSWORDRESET",
    packageName: "",
  },
  GETUSERDTLFROM360: {
    url: "commonServiceAPI/GETUSERDTLFROM360",
    packageName: "",
  },
  UPDATECUSTREFRESHDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/UPDATECUSTREFRESHDATA",
    packageName: "",
  },
  GETUSERTRNLIMITDTL: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETUSERTRNLIMITDTL",
    packageName: "",
  },
  USERLIMITACCEPTREJECTDATA: {
    url: "operationServiceAPI/USERLIMITACCEPTREJECTDATA",
    packageName: "",
  },
  GETLOANCLSCONFREQ: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETLOANCLSCONFREQ",
    packageName: "",
  },
  GETLOANCLSDETAIL: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETLOANCLSDETAIL",
    packageName: "",
  },
  UPDATELOANCLSCONF: {
    url: "operationServiceAPI/UPDATELOANCLSCONF",
    packageName: "",
  },
  LOANAPPLYREQ: {
    url: "commonServiceAPI/GETDYNAMICDATA/LOANAPPLYREQ",
    packageName: "",
  },
  LOANAPPROVALPROCESS_CIB: {
    url: "commonServiceAPI/GETDYNAMICDATA/LOANAPPROVALPROCESS_CIB",
    packageName: "",
  },
  LOANREQCIBACCEPT: {
    url: "commonServiceAPI/GETDYNAMICDATA/LOANREQCIBACCEPT",
    packageName: "",
  },
  LOANREQREJECT: {
    url: "operationServiceAPI/LOANREQREJECT",
    packageName: "",
  },
  LOANAPPROVALPROCESS_DBR: {
    url: "commonServiceAPI/GETDYNAMICDATA/LOANAPPROVALPROCESS_DBR",
    packageName: "",
  },
  GETLOANAPPDOCUMENTDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETLOANAPPDOCUMENTDATA",
    packageName: "",
  },
  LOANREQDBRACCEPT: {
    url: "operationServiceAPI/LOANREQDBRACCEPT",
    packageName: "",
  },
  LOANAPPROVALPROCESS_AUTH: {
    url: "commonServiceAPI/GETDYNAMICDATA/LOANAPPROVALPROCESS_AUTH",
    packageName: "",
  },
  LOANREQAUTHACCEPT: {
    url: "operationServiceAPI/LOANREQAUTHACCEPT",
    packageName: "",
  },
  GETPRIMARYIDCHANGEDATA: {
    url: "operationServiceAPI/GETPRIMARYIDCHANGEDATA",
    packageName: "",
  },
  INSPRIMARYSOURCE: {
    url: "commonServiceAPI/GETDYNAMICDATA/INSPRIMARYSOURCE",
    packageName: "",
  },
  PENPRIMARYSOURCE: {
    url: "commonServiceAPI/GETDYNAMICDATA/PENPRIMARYSOURCE",
    packageName: "",
  },
  CONFPRIMARYSOURCE: {
    url: "operationServiceAPI/CONFPRIMARYSOURCE",
    packageName: "",
  },
  TAGREQUEST: {
    url: "operationServiceAPI/TAGREQUEST",
    packageName: "",
  },
  TAGREQUESTUPDATE: {
    url: "operationServiceAPI/TAGREQUESTUPDATE",
    packageName: "",
  },
  GETEMI: {
    url: "commonServiceAPI/GETEMI",
    packageName: "",
  },
  // GETBILLERLIST: {
  //   url: "commonServiceAPI/GETDYNAMICDATA/GETBILLERLIST",
  //   packageName: "",
  // },
  // GETBILLERFIELDLIST: {
  //   url: "commonServiceAPI/GETDYNAMICDATA/GETBILLERFIELDLIST",
  //   packageName: "",
  // },
  GETBILLERURLPARALIST: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETBILLERURLPARALIST",
    packageName: "",
  },
  GETFIELDOPTIONLIST: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETFIELDOPTIONLIST",
    packageName: "",
  },
  SERVICECHARGEDML: {
    url: "configurationServiceAPI/SERVICECHARGEDML",
    packageName: "",
  },
  SERVICEWISECONFIGGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/SERVICEWISECONFIGGRID",
    packageName: "",
  },
  GETCHARGETEMPLATELIST: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETCHARGETEMPLATELIST",
    packageName: "",
  },
  GETSERVICEAMTLABELSLIST: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETSERVICEAMTLABELSLIST",
    packageName: "",
  },
  GETSERVICECONFIGDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETSERVICECONFIGDATA",
    packageName: "",
  },
  GETPARACONFIRMGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETPARACONFIRMGRID",
    packageName: "",
  },
  GETSERVICECONFIRMGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETSERVICECONFIRMGRID",
    packageName: "",
  },
  GETBANKMASTERGRIDDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETBANKMASTERGRIDDATA",
    packageName: "",
  },
  // GETSERVICEACTVCONFIGGRID: {
  //   url: "commonServiceAPI/GETDYNAMICDATA/GETSERVICEACTVCONFIGGRID",
  //   packageName: "",
  // },
  GETSERVICEACTVCONFIGDTLGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETSERVICEACTVCONFIGDTLGRID",
    packageName: "",
  },
  GETBRANCHMSTGRIDDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETBRANCHMSTGRIDDATA",
    packageName: "",
  },
  GETDISTMSTGRIDDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETDISTMSTGRIDDATA",
    packageName: "",
  },
  GETOPERATORDTLGRIDDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETOPERATORDTLGRIDDATA",
    packageName: "",
  },
  GETOPERATORMASTERGRIDDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETOPERATORMASTERGRIDDATA",
    packageName: "",
  },
  GETDISTRICTLIST: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETDISTRICTLIST",
    packageName: "",
  },
  GETEMAILSMSTEMPLATEGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETEMAILSMSTEMPLATEGRID",
    packageName: "",
  },
  GETEMAILSMSCONFIGDTLLIST: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETEMAILSMSCONFIGDTLLIST",
    packageName: "",
  },
  GETEMAILACCTCONFIGDROPDOWN: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETEMAILACCTCONFIGDROPDOWN",
    packageName: "",
  },
  USERSLIMITDML: {
    url: "operationServiceAPI/USERSLIMITDML",
    packageName: "",
  },
  BANKMASTERUPDATEDML: {
    url: "configurationServiceAPI/BANKMASTERUPDATEDML",
    packageName: "",
  },
  BANKMASTERDELETEDML: {
    url: "configurationServiceAPI/BANKMASTERDELETEDML",
    packageName: "",
  },
  FILEUPDBANKMASTER: {
    url: "commonServiceAPI/BANKMASTER",
    packageName: "",
  },
  OPERATORMSTDML: {
    url: "configurationServiceAPI/OPERATORMSTDML",
    packageName: "",
  },
  GETOPERATORSDTGRIDDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETOPERATORSDTGRIDDATA",
    packageName: "",
  },
  OPERATORSUBDETAILDML: {
    url: "configurationServiceAPI/OPERATORSUBDETAILDML",
    packageName: "",
  },
  GETSCHEMEMASTERGRIDDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETSCHEMEMASTERGRIDDATA",
    packageName: "",
  },
  GETSCHEMEDETAILDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETSCHEMEDETAILDATA",
    packageName: "",
  },
  GETPARENTTYPEDROPDOWN: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETPARENTTYPEDROPDOWN",
    packageName: "",
  },
  GETLEAFTEMPLATEDROPDOWN: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETLEAFTEMPLATEDROPDOWN",
    packageName: "",
  },
  UPDATEPARAMST: {
    url: "configurationServiceAPI/UPDATEPARAMST",
    packageName: "",
  },
  PARAMSTCONFIRM: {
    url: "configurationServiceAPI/PARAMSTCONFIRM",
    packageName: "",
  },
  GETOTHERENTITYGRIDDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETOTHERENTITYGRIDDATA",
    packageName: "",
  },
  GETOTHERENTITYDETAILDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETOTHERENTITYDETAILDATA",
    packageName: "",
  },
  OTHERENTITYDML: {
    url: "configurationServiceAPI/OTHERENTITYDML",
    packageName: "",
  },
  // UPDATESERVICEWISECONFIG: {
  //   url: "configurationServiceAPI/UPDATESERVICEWISECONFIG",
  //   packageName: "",
  // },
  SERVICEWISECONFIGCONFIRM: {
    url: "configurationServiceAPI/SERVICEWISECONFIGCONFIRM",
    packageName: "",
  },
  REGISTRATIONCUSTRPT: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETREGISTERCUSTRPTDATA",
    packageName: "",
  },
  UPDCLUBMASTERDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/UPDCLUBMASTERDATA",
    packageName: "",
  },
  DISTRICTMSTDML: {
    url: "configurationServiceAPI/DISTRICTMSTDML",
    packageName: "",
  },
  GETSOURCEPARENTTYPEGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETSOURCEPARENTTYPEGRID",
    packageName: "",
  },
  SOURCEPARENTTYPEDML: {
    url: "configurationServiceAPI/SOURCEPARENTTYPEDML",
    packageName: "",
  },
  GETDYNAMICREPORTMETADATA: {
    url: "reportServiceAPI/GETDYNAMICREPORTMETADATA",
    packageName: "",
  },
  GETDYNRPTCONFIGGRIDDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETDYNRPTCONFIGGRIDDATA",
    packageName: "",
  },
  VERIFYDYNREPORTQUERY: {
    url: "reportServiceAPI/VERIFYDYNREPORTQUERY",
    packageName: "",
  },
  SCHEMEMSTDML: {
    url: "configurationServiceAPI/SCHEMEMSTDML",
    packageName: "",
  },
  GETDYNRPTCONFIGDATA: {
    url: "reportServiceAPI/GETDYNRPTCONFIGDATA",
    packageName: "",
  },
  BILLERINFO: {
    url: "configurationServiceAPI/BILLERINFO",
    packageName: "",
  },
  REFRESHBILLERMETADATA: {
    url: "configurationServiceAPI/REFRESHBILLERMETADATA",
    packageName: "",
  },
  SERVICEACTIVEDEACTIVEDTLDML: {
    url: "configurationServiceAPI/SERVICEACTIVEDEACTIVEDTLDML",
    packageName: "",
  },
  DYNBILLERSCREENNOTEDML: {
    url: "configurationServiceAPI/DYNBILLERSCREENNOTEDML",
    packageName: "",
  },
  GETADMINUSERGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETADMINUSERGRID",
    packageName: "",
  },
  GETACCTDELETIONCONFIRMLIST: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETACCTDELETIONCONFIRMLIST",
    packageName: "",
  },
  GETSECURITYGROUPINGLIST: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETSECURITYGROUPINGLIST",
    packageName: "",
  },
  SECURITYUSERDML: {
    url: "configurationServiceAPI/SECURITYUSERDML",
    packageName: "",
  },
  GETUSERSNOTIFTEMPLIST: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETUSERSNOTIFTEMPLIST",
    packageName: "",
  },
  GETSCREENNOTEGRIDDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETSCREENNOTEGRIDDATA",
    packageName: "",
  },
  DYNAMICREPORTCONFIGDML: {
    url: "reportServiceAPI/DYNAMICREPORTCONFIGDML",
    packageName: "",
  },
  ACCTDELETIONRPT: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETACCTDELETERPT",
    packageName: "",
  },
  LOGINHISTORYRPT: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETLOGINHISTORYRPT",
    packageName: "",
  },
  GETOPERATORMSTCONFIRMGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETOPERATORMSTCONFIRMGRID",
    packageName: "",
  },
  GETMERCHONBOARDGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETMERCHONBOARDGRID",
    packageName: "",
  },
  GETMERCHANTMASTERDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETPGWMERCHANTMASTERDATA",
    packageName: "",
  },
  GETBILLERCHARGECONFIRMDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETBILLERCHARGECONFIRMDATA",
    packageName: "",
  },
  DYNBILLERCHARGEMSTCONFIRM: {
    url: "configurationServiceAPI/DYNBILLERCHARGEMSTCONFIRM",
    packageName: "",
  },
  GETFROMSOURCELIST: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETFROMSOURCELIST",
    packageName: "",
  },
  GETFROMSOURCECONFIGGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETFROMSOURCECONFIGGRID",
    packageName: "",
  },
  GETFROMSOURCECONFIGDTLDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETFROMSOURCECONFIGDTLDATA",
    packageName: "",
  },
  GETFROMSOURCETEMPLATEDD: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETFROMSOURCETEMPLATEDD",
    packageName: "",
  },
  GETFROMSOURCECONFIGSDTDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETFROMSOURCECONFIGSDTDATA",
    packageName: "",
  },
  GETFROMACCTTEMPMSTGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETFROMACCTTEMPMSTGRID",
    packageName: "",
  },
  GETFROMACCTTEMPDTLDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETFROMACCTTEMPDTLDATA",
    packageName: "",
  },
  GETAPPVERSIONMSTGRIDDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETAPPVERSIONMSTGRIDDATA",
    packageName: "",
  },
  GETUSERBLOCKCONFIGGRIDDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETUSERBLOCKCONFIGGRIDDATA",
    packageName: "",
  },
  GETMFSCONFIGGRIDDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETMFSCONFIGGRIDDATA",
    packageName: "",
  },
  GETMERCHANTGRIDDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETMERCHANTGRIDDATA",
    packageName: "",
  },
  GETPGWMERUSERGRIDDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETPGWMERUSERGRIDDATA",
    packageName: "",
  },
  GETBENERESGRIDDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETBENERESGRIDDATA",
    packageName: "",
  },
  GETFILECONFIGDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETFILECONFIGDATA",
    packageName: "",
  },
  GETGUESSPWDDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETGUESSPWDDATA",
    packageName: "",
  },
  GETUSERSESSDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETUSERSESSDATA",
    packageName: "",
  },
  GETUSERBLOKDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETUSERBLOKDATA",
    packageName: "",
  },
  GETUSERBLOKDTLDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETUSERBLOKDTLDATA",
    packageName: "",
  },
  GETROOTDEVLIST: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETROOTDEVLIST",
    packageName: "",
  },

  UPDSECURITYGROUPING: {
    url: "commonServiceAPI/userAccessManagement/SECURITYGROUPINGDML",
    packageName: "",
  },
  UPDUSERNOTIFTMPL: {
    url: "commonServiceAPI/userAccessManagement/USERNOTIFTEMPDML",
    packageName: "",
  },

  GETBANNDTLGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETBANNDTLGRID",
    packageName: "",
  },
  CONFIRMSCHEMEMASTER: {
    url: "configurationServiceAPI/CONFIRMSCHEMEMASTER",
    packageName: "",
  },
  OPERATORMSTCONFIRM: {
    url: "configurationServiceAPI/OPERATORMSTCONFIRM",
    packageName: "",
  },
  FROMACCOUNTCONFIGDML: {
    url: "configurationServiceAPI/FROMACCOUNTCONFIGDML",
    packageName: "",
  },
  CONFROOTDEVICEPERM: {
    url: "operationServiceAPI/CONFROOTDEVICEPERM",
    packageName: "",
  },

  SERVICEMOBVALID: {
    url: "configurationServiceAPI/SERVICEMOBVALIDDML",
    packageName: "",
  },
  //product name configration
  GETPRODUCTDISPNMGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETPRODUCTDISPNMGRID",
    packageName: "",
  },
  GETPRODUCTDISPNMDTLDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETPRODUCTDISPNMDTLDATA",
  },
  SERVICECHARGECONFIRM: {
    url: "configurationServiceAPI/SERVICECHARGECONFIRM",
    packageName: "",
  },
  SERVICEWISEAMOUNTLABELDML: {
    url: "configurationServiceAPI/SERVICEWISEAMOUNTLABELDML",
    packageName: "",
  },
  UPDACCOUNTDELETIONREQ: {
    url: "operationServiceAPI/UPDACCOUNTDELETIONREQ",
    packageName: "",
  },
  USERBLOCKCONFIGCONFIRM: {
    url: "configurationServiceAPI/USERBLOCKCONFIGCONFIRM",
    packageName: "",
  },
  GETOTPSMSCONFIGGRID: {
    url: "/commonServiceAPI/GETDYNAMICDATA/GETOTPSMSCONFIGGRID",
    packageName: "",
  },
  GETTRANOTPSMSTAGLIST: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETTRANOTPSMSTAGLIST",
    packageName: "",
  },
  GETIDTPCHARGEMSTGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETIDTPCHARGEMSTGRID",
    packageName: "",
  },
  GETIDTPCHARGECONFIRMGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETIDTPCHARGECONFIRMGRID",
    packageName: "",
  },
  OTPMESSAGECONFIG: {
    url: "configurationServiceAPI/OTPMESSAGECONFIG",
    packageName: "",
  },
  GETADMINUSERCONFIRMGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETADMINUSERCONFIRMGRID",
    packageName: "",
  },
  GETSECURITYUSERAUDITGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETSECURITYUSERAUDITGRID",
    packageName: "",
  },
  UPLOADFDRSCHEMEDATA: {
    url: "configurationServiceAPI/UPLOADFDRSCHEMEDATA",
    packageName: "",
  },
  GETTENURECONFIGGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETTENURECONFIGGRID",
    packageName: "",
  },
  CARDBINIMAGEDML: {
    url: "configurationServiceAPI/CARDBINIMAGEDML",
    packageName: "",
  },
  USERBLOCKCONFIGDML: {
    url: "configurationServiceAPI/USERBLOCKCONFIGDML",
    packageName: "",
  },
  ENCEMAILDML: {
    url: "configurationServiceAPI/ENCEMAILDML",
    packageName: "",
  },
  PRODUCTDISPNMDML: {
    url: "configurationServiceAPI/PRODUCTDISPNMDML",
    packageName: "",
  },
  GETBRANCHLIST: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETBRANCHLIST",
    packageName: "",
  },
  FDTYPEHDRDTLDML: {
    url: "configurationServiceAPI/FDTYPEHDRDTLDML ",
    packageName: "",
  },
  FDTYPESDTDML: {
    url: "configurationServiceAPI/FDTYPESDTDML ",
    packageName: "",
  },
  GETFDTYPEDTLDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETFDTYPEDTLDATA",
    packageName: "",
  },
  GETFDTYPESDTDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETFDTYPESDTDATA",
    packageName: "",
  },
  UPDSECURITYUSER: {
    url: "commonServiceAPI/userAccessManagement/UPDSECURITYUSER",
    packageName: "",
  },
  // GETEUSERMSTDATA: {
  //   url: "configurationServiceAPI/GETEUSERMSTDATA",
  //   packageName: "",
  // },
  GETEUSERMSTDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETEUSERMSTDATA",
    packageName: "",
  },
  CONFIRMMERCHANTONBOARD: {
    url: "configurationServiceAPI/CONFIRMMERCHANTONBOARD",
    packageName: "",
  },
  MERCHANTONBOARDCONFIG: {
    url: "configurationServiceAPI/MERCHANTONBOARDCONFIG",
    packageName: "",
  },
  ATMMASTERDML: {
    url: "configurationServiceAPI/ATMMASTERDML",
    packageName: "",
  },
  LOGINBLOCKUSER: {
    url: "commonServiceAPI/userAccessManagement/LOGINBLOCKUSER",
    packageName: "",
  },
  APPLYSESSIONTRAN: {
    url: "commonServiceAPI/userAccessManagement/APPLYSESSIONTRAN",
    packageName: "",
  },
  UPDROOTDEVICEPERM: {
    url: "operationServiceAPI/UPDROOTDEVICEPERM",
    packageName: "",
  },
  GETUSERDTL360: {
    url: "operationServiceAPI/GETUSERDTL360",
    packageName: "",
  },
  APPVERSIONMSTDML: {
    url: "configurationServiceAPI/APPVERSIONMSTDML",
    packageName: "",
  },
  COPYMENURIGHTS: {
    url: "commonServiceAPI/userAccessManagement/COPYMENURIGHTS",
    packageName: "",
  },
  DEFAULTSCREENRIGHT: {
    url: "commonServiceAPI/userAccessManagement/DEFAULTSCREENRIGHT",
    packageName: "",
  },
  ADDMENURIGHTS: {
    url: "commonServiceAPI/userAccessManagement/ADDMENURIGHTS",
    packageName: "",
  },
  GETMENUUSERRIGHTS: {
    url: "commonServiceAPI/userAccessManagement/GETMENUUSERRIGHTS",
    packageName: "",
  },
  GETDBILLSUBCATEGORYLIST: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETDBILLSUBCATEGORYLIST",
    packageName: "",
  },
  GETDYNBILLERLIST: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETDYNBILLERLIST",
    packageName: "",
  },
  GETDDMERCHANTLIST: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETDDMERCHANTLIST",
    packageName: "",
  },
  PWDRESET: {
    url: "commonServiceAPI/PWDRESET",
    packageName: "",
  },
  PWDRESETVERIFY: {
    url: "commonServiceAPI/PWDRESETVERIFY",
    packageName: "",
  },
  PWDRESETUPDATE: {
    url: "commonServiceAPI/PWDRESETUPDATE",
    packageName: "",
  },
  OTPRESEND: {
    url: "commonServiceAPI/OTPRESEND",
    packageName: "",
  },
  DOTOTPAUTHUPDATE: {
    url: "userRegistrationServiceAPI/DOTOTPAUTHUPDATE",
    packageName: "",
  },
  DOTOTPAUTHUPDATEVERIFY: {
    url: "userRegistrationServiceAPI/DOTOTPAUTHUPDATEVERIFY",
    packageName: "",
  },
  GETEMPLOYEEPROFILEPIC: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETEMPLOYEEPROFILEPIC",
    packageName: "",
  },
  GETVIRTUALCARDPRODTYPEGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETVIRTUALCARDPRODTYPEGRID",
    packageName: "",
  },
  GETVCARDPRODTYPEDTLGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETVCARDPRODTYPEDTLGRID",
    packageName: "",
  },
  VCARDPRODUCTTYPECONFIGDML: {
    url: "configurationServiceAPI/VCARDPRODUCTTYPECONFIGDML",
    packageName: "",
  },
  VCARDPRODUCTTYPECONFIRM: {
    url: "configurationServiceAPI/VCARDPRODUCTTYPECONFIRM",
    packageName: "",
  },
  SETFROMKEYTEMPLATE: {
    url: "operationServiceAPI/SETFROMKEYTEMPLATE",
    packageName: "",
  },
  GETCARDIMAGELIST: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETCARDIMAGELIST",
    packageName: "",
  },
  CARDIMAGEDML: {
    url: "configurationServiceAPI/CARDIMAGEDML",
    packageName: "",
  },
  GETCARDIMAGE: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETCARDIMAGE",
    packageName: "",
  },
  CARDIMAGECONFIRM: {
    url: "configurationServiceAPI/CARDIMAGECONFIRM",
    packageName: "",
  },
  GETINSTANCEDETAILS: {
    url: "commonServiceAPI/GETINSTANCEDETAILS",
    packageName: "",
  },

  //

  GETSCREENNOTEDTLDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETSCREENNOTEDTLDATA",
    packageName: "",
  },

  GETVALIDATIONMSGGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETVALIDATIONMSGGRID",
    packageName: "",
  },
  GETVALIDATIONMSGDTLDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETVALIDATIONMSGDTLDATA",
    packageName: "",
  },
  GETCHARGETEMPLATEGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETCHARGETEMPLATEGRID",
    packageName: "",
  },
  GETCHARGETEMPLATEDTLDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETCHARGETEMPLATEDTLDATA",
    packageName: "",
  },
  SCREENMSGMSTDML: {
    url: "configurationServiceAPI/SCREENMSGMSTDML",
    packageName: "",
  },
  MESSAGEVALIDATIONUPDATE: {
    url: "configurationServiceAPI/MESSAGEVALIDATIONUPDATE",
    packageName: "",
  },
  GETCOMMONMSGGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETCOMMONMSGGRID",
    packageName: "",
  },
  GETCOMMONMSGDTLDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETCOMMONMSGDTLDATA",
    packageName: "",
  },
  COMMONMSGDML: {
    url: "configurationServiceAPI/COMMONMSGDML",
    packageName: "",
  },
  GETMARQUEEMESSAGEGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETMARQUEEMESSAGEGRID",
    packageName: "",
  },
  GETEMAILACCTGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETEMAILACCTGRID",
    packageName: "",
  },
  GETPASSPOLICYGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETPASSPOLICYGRID",
    packageName: "",
  },
  PASSWORDPOLICYDML: {
    url: "configurationServiceAPI/PASSWORDPOLICYDML",
    packageName: "",
  },
  GETBENERESGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETBENERESGRID",
    packageName: "",
  },
  BENEFRESTRICTCONFIGDML: {
    url: "configurationServiceAPI/BENEFRESTRICTCONFIGDML",
    packageName: "",
  },
  UPDOTPMSGCONFIG: {
    url: "configurationServiceAPI/UPDOTPMSGCONFIG",
    packageName: "",
  },
  GETCONFCHARGETEMPLATEGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETCONFCHARGETEMPLATEGRID",
    packageName: "",
  },
  GETPARAMETERMSTGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETPARAMETERMSTGRID",
    packageName: "",
  },
  GETUSERBLOCKCONFIGGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETUSERBLOCKCONFIGGRID",
    packageName: "",
  },
  GETMSMESSAGEDTLGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETMSMESSAGEDTLGRID",
    packageName: "",
  },
  GETSTATICREPORTMETADATA: {
    url: "reportServiceAPI/GETSTATICREPORTMETADATA",
    packageName: "",
  },
  GETSTATICREPORTDTLMETADATA: {
    url: "reportServiceAPI/GETSTATICREPORTDTLMETADATA",
    packageName: "",
  },
  // Service Active Deactive Configuration Screen
  GETSERVICEACTVCONFIGGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETSERVICEACTVCONFIGGRID",
    packageName: "",
  },
  SERVICEACTIVEDEACTIVEMSTDML: {
    url: "configurationServiceAPI/SERVICEACTIVEDEACTIVEMSTDML",
    packageName: "",
  },
  GETSECURITYUSERSLIST: {
    url: "/commonServiceAPI/GETDYNAMICDATA/GETSECURITYUSERSLIST",
    packageName: "",
  },
  TBGUSERLOG: {
    url: "/commonServiceAPI/TBGUSERLOG",
    packageName: "",
  },
  GETSECURITYQUESTIONDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETSECURITYQUESTIONDATA",
    packageName: "",
  },
  SECURITYQUESTIONDML: {
    url: "configurationServiceAPI/SECURITYQUESTIONDML",
    packageName: "",
  },
  SECURITYQUESTIONCONFIRM: {
    url: "configurationServiceAPI/SECURITYQUESTIONCONFIRM",
    packageName: "",
  },
  //
  EMAILMSGCONFIGUPDATEDML: {
    url: "configurationServiceAPI/EMAILMSGCONFIGUPDATEDML",
    packageName: "",
  },
  GETSMSTEMPLATE: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETSMSTEMPLATE",
    packageName: "",
  },
  GETEMAILTEMPLATE: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETEMAILTEMPLATE",
    packageName: "",
  },
  USERMARQEEMSGDML: {
    url: "configurationServiceAPI/USERMARQEEMSGDML",
    packageName: "",
  },
  GETFILECONFIGFILEDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETFILECONFIGFILEDATA",
    packageName: "",
  },
  GUIDELINEFILECONFIGDML: {
    url: "configurationServiceAPI/GUIDELINEFILECONFIGDML",
    packageName: "",
  },
  FROMACCOUNTSDTCONFIGDML: {
    url: "configurationServiceAPI/FROMACCOUNTSDTCONFIGDML",
    packageName: "",
  },
  GETCARDACTVDACTVGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETCARDACTVDACTVGRID",
    packageName: "",
  },
  GETMOBILEVALTEMPLLIST: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETMOBILEVALTEMPLLIST",
    packageName: "",
  },
  GETMOBILEVALIDTLDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETMOBILEVALIDTLDATA",
    packageName: "",
  },
  MOBVALIDTEMPDML: {
    url: "configurationServiceAPI/MOBVALIDTEMPDML",
    packageName: "",
  },
  GETSERVMOBILVALGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETSERVMOBILVALGRID",
    packageName: "",
  },
  SERVICEMOBVALIDCONFIRM: {
    url: "configurationServiceAPI/SERVICEMOBVALIDCONFIRM",
    packageName: "",
  },
  GETSERVMONITORGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETSERVMONITORGRID",
    packageName: "",
  },
  GETMSMESSAGEGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETMSMESSAGEGRID",
    packageName: "",
  },
  MSGCONFIGMSTDML: {
    url: "configurationServiceAPI/MSGCONFIGMSTDML",
    packageName: "",
  },
  GETMSPROPGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETMSPROPGRID",
    packageName: "",
  },
  GETMSPROPDTLGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETMSPROPDTLGRID",
    packageName: "",
  },
  PROPERTIESCONFIGDML: {
    url: "configurationServiceAPI/PROPERTIESCONFIGDML",
    packageName: "",
  },
  GETPAGECONTENTGRIDDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETPAGECONTENTGRIDDATA",
    packageName: "",
  },
  GETAUDITDATA: {
    url: "commonServiceAPI/GETAUDITDATA",
    packageName: "",
  },
  GETUSERGROUPGRIDDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETUSERGROUPGRIDDATA",
    packageName: "",
  },
  GETUSERPUSHGRIDDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETUSERPUSHGRIDDATA",
    packageName: "",
  },
  GETEMISCGRIDDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETEMISCGRIDDATA",
    packageName: "",
  },
  MISCMASTERDML: {
    url: "configurationServiceAPI/MISCMASTERDML",
    packageName: "",
  },
  GETALLACCOUNTCARDDETAIL: {
    url: "operationServiceAPI/GETALLACCOUNTCARDDETAIL",
    packageName: "",
  },
  APPREVIWEUSERMSTDML: {
    url: "configurationServiceAPI/APPREVIWEUSERMSTDML",
    packageName: "",
  },
  GETUSERPUSHDTLDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETUSERPUSHDTLDATA",
    packageName: "",
  },
  GETOTHERBANKLIST: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETOTHERBANKLIST",
    packageName: "",
  },
  GETOTHERBRANCHLIST: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETOTHERBRANCHLIST",
    packageName: "",
  },
  GETOTHERREGIONLIST: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETOTHERREGIONLIST",
    packageName: "",
  },
  GETSTATETOWNSHIPDETAILS: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETSTATETOWNSHIPDETAILS",
    packageName: "",
  },
  STATETOWNSHIPDML: {
    url: "configurationServiceAPI/STATETOWNSHIPDML",
    packageName: "",
  },
  GETSUSACCOUNTTMPLREQDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETSUSACCOUNTTMPLREQDATA",
    packageName: "",
  },
  REQSUSACCTTMPLDML: {
    url: "configurationServiceAPI/REQSUSACCTTMPLDML",
    packageName: "",
  },
  SUSACCOUNTTMPLREQCONFIRM: {
    url: "configurationServiceAPI/SUSACCOUNTTMPLREQCONFIRM",
    packageName: "",
  },
  GETSUSACCOUNTTMPLDTLDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETSUSACCOUNTTMPLDTLDATA",
    packageName: "",
  },
  GETCOMMONUTILVALUE: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETCOMMONUTILVALUE",
    packageName: "",
  },
  GETCURRLIMTMPLREQDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETCURRLIMTMPLREQDATA",
    packageName: "",
  },
  GETUSERLIMITDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETUSERLIMITDATA",
    packageName: "",
  },
  REQCURRLIMTMPLDML: {
    url: "configurationServiceAPI/REQCURRLIMTMPLDML",
    packageName: "",
  },
  CURRLIMITTMPLREQCONFIRM: {
    url: "configurationServiceAPI/CURRLIMITTMPLREQCONFIRM",
    packageName: "",
  },
  GETREQCURRLIMITTMPLDTLDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETREQCURRLIMITTMPLDTLDATA",
    packageName: "",
  },
  GETHOLIDAYDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETHOLIDAYDATA",
    packageName: "",
  },
  GETHOLIDAYDTLDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETHOLIDAYDTLDATA",
    packageName: "",
  },
  HOLIDAYMSTDTLDML: {
    url: "configurationServiceAPI/HOLIDAYMSTDTLDML",
    packageName: "",
  },
  GENBUSINESSDAY: {
    url: "configurationServiceAPI/GENBUSINESSDAY",
    packageName: "",
  },
  GETBUSINESSDAYDTLGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETBUSINESSDAYDTLGRID",
    packageName: "",
  },
  // GETACCTCHARGETEMPMSTDATA: {
  //   url: "commonServiceAPI/GETDYNAMICDATA/GETACCTCHARGETEMPMSTDATA",
  //   packageName: "",
  // },
  GETACCTCHARGEREQGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETACCTCHARGEREQGRID",
    packageName: "",
  },
  // GETACCTCHARGETEMPDTLDATA: {
  //   url: "commonServiceAPI/GETDYNAMICDATA/GETACCTCHARGETEMPDTLDATA",
  //   packageName: "",
  // },
  GETACCTCHARGEDTLGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETACCTCHARGEDTLGRID",
    packageName: "",
  },
  // GETACCTCHARGETEMPSDTDATA: {
  //   url: "commonServiceAPI/GETDYNAMICDATA/GETACCTCHARGETEMPSDTDATA",
  //   packageName: "",
  // },
  GETACCTCHARGESDTGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETACCTCHARGESDTGRID",
    packageName: "",
  },
  ACCOUNTCHARGEMSTDTLDML: {
    url: "configurationServiceAPI/ACCOUNTCHARGEMSTDTLDML",
    packageName: "",
  },
  ACCOUNTCHARGESUBDTLDML: {
    url: "configurationServiceAPI/ACCOUNTCHARGESUBDTLDML",
    packageName: "",
  },
  ACCOUNTCHARGECONFIRM: {
    url: "configurationServiceAPI/ACCOUNTCHARGECONFIRM",
    packageName: "",
  },
  GETREQPROFILEMSTDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETREQPROFILEMSTDATA",
    packageName: "",
  },
  GETREQPROFILEDTLDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETREQPROFILEDTLDATA",
    packageName: "",
  },
  REQPROFILEDML: {
    url: "configurationServiceAPI/REQPROFILEDML",
    packageName: "",
  },
  PROFILEREQCONFIRM: {
    url: "configurationServiceAPI/PROFILEREQCONFIRM",
    packageName: "",
  },
  FROMSOURCETEMPLTDML: {
    url: "configurationServiceAPI/FROMSOURCETEMPLTDML",
    packageName: "",
  },
  GETREQSERVICEMSTDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETREQSERVICEMSTDATA",
    packageName: "",
  },
  GETREQSERCURRSUSPDTLDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETREQSERCURRSUSPDTLDATA",
    packageName: "",
  },
  GETREQSERSOURCECHRGDTLDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETREQSERSOURCECHRGDTLDATA",
    packageName: "",
  },
  SERVICEMSTDML: {
    url: "configurationServiceAPI/SERVICEMSTDML",
    packageName: "",
  },
  SERVICEREQCONFIRM: {
    url: "configurationServiceAPI/SERVICEREQCONFIRM",
    packageName: "",
  },
  AMOUNTLABELDTLDML: {
    url: "configurationServiceAPI/AMOUNTLABELDTLDML",
    packageName: "",
  },
  GETSERVICEPRESETAMTDTLDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETSERVICEPRESETAMTDTLDATA",
    packageName: "",
  },
  GETPROFILETEMPLATELIST: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETPROFILETEMPLATELIST",
    packageName: "",
  },
  SETUSERPROFILE: {
    url: "operationServiceAPI/SETUSERPROFILE",
    packageName: "",
  },
  GETWALLETGRIDDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETWALLETGRIDDATA",
    packageName: "",
  },
  WALLETMSTDML: {
    url: "configurationServiceAPI/WALLETMSTDML",
    packageName: "",
  },
  WALLETMSTCONFIRM: {
    url: "configurationServiceAPI/WALLETMSTCONFIRM",
    packageName: "",
  },
  BUSINESSDAYCONFIGDML: {
    url: "configurationServiceAPI/BUSINESSDAYCONFIGDML",
    packageName: "",
  },
  GETCURRLIMTMPLMSTDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETCURRLIMTMPLMSTDATA",
    packageName: "",
  },
  GETSUSACCOUNTTMPLMSTDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETSUSACCOUNTTMPLMSTDATA",
    packageName: "",
  },
  GETCHARGETEMPLATEMSTGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETCHARGETEMPLATEMSTGRID",
    packageName: "",
  },
  GETCARDSTATUSMSTGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETCARDSTATUSMSTGRID",
    packageName: "",
  },
  GETCARDSTATUSDTLGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETCARDSTATUSDTLGRID",
    packageName: "",
  },
  CARDACTIVEDEACTIVEDML: {
    url: "configurationServiceAPI/CARDACTIVEDEACTIVEDML",
    packageName: "",
  },
  // card apply confirmation
  GETAPPLIEDACCTCHRGDTL: {
    url: "operationServiceAPI/GETAPPLIEDACCTCHRGDTL",
    packageName: "",
  },
  GETAPPLYCARDREQGRIDDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETAPPLYCARDREQGRIDDATA",
    packageName: "",
  },
  GETAPPLYCARDPARTIESDOCGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETAPPLYCARDPARTIESDOCGRID",
    packageName: "",
  },
  GETAPPLYCARDPARTIESDTLGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETAPPLYCARDPARTIESDTLGRID",
    packageName: "",
  },
  CARDREQCONFIRM: {
    url: "operationServiceAPI/CARDREQCONFIRM",
    packageName: "",
  },
  // Branch Master
  GETBRANCHDTLGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETBRANCHDTLGRID",
    packageName: "",
  },
  GETBRANCHMSTGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETBRANCHMSTGRID",
    packageName: "",
  },
  BRANCHMASTERDML: {
    url: "configurationServiceAPI/BRANCHMASTERDML",
    packageName: "",
  },
  CONFIRMBRANCH: {
    url: "configurationServiceAPI/CONFIRMBRANCH",
    packageName: "",
  },
  GETUSERAPPLIEDLIMIT: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETUSERAPPLIEDLIMIT",
    packageName: "",
  },
  GETCARDPRDREQGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETCARDPRDREQGRID",
    packageName: "",
  },
  GETCARDPRDDTLREQGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETCARDPRDDTLREQGRID",
    packageName: "",
  },
  CARDPRODUCTREQDML: {
    url: "configurationServiceAPI/CARDPRODUCTREQDML",
    packageName: "",
  },
  CARDPRODUCTREQCONFIRM: {
    url: "configurationServiceAPI/CARDPRODUCTREQCONFIRM",
    packageName: "",
  },
  GETSERVICECONFIGCHANNELGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETSERVICECONFIGCHANNELGRID",
    packageName: "",
  },
  GETSERVICECONFIGPROFILEGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETSERVICECONFIGPROFILEGRID",
    packageName: "",
  },
  GETFROMSOURCECONFIGCONFGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETFROMSOURCECONFIGCONFGRID",
    packageName: "",
  },
  FROMACCOUNTCONFIGCONFIRM: {
    url: "configurationServiceAPI/FROMACCOUNTCONFIGCONFIRM",
    packageName: "",
  },
  GETREQCURRLIMTMPLSDTGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETREQCURRLIMTMPLSDTGRID",
    packageName: "",
  },
  REQCURRLIMSUBDTLDML: {
    url: "configurationServiceAPI/REQCURRLIMSUBDTLDML",
    packageName: "",
  },
  GETOTHERBRANCHDTLDATA: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETOTHERBRANCHDTLDATA",
    packageName: "",
  },
  OTHERBRANCHDML: {
    url: "configurationServiceAPI/OTHERBRANCHDML",
    packageName: "",
  },
  UPDBRANCHSERVICESTATUS: {
    url: "configurationServiceAPI/UPDBRANCHSERVICESTATUS",
    packageName: "",
  },
  GETCORPORATEDTL: {
    url: "operationServiceAPI/GETCORPORATEDTL",
    packageName: "",
  },
  CRPMANAGEDML: {
    url: "operationServiceAPI/CRPMANAGEDML",
    packageName: "",
  },
  CRPUSERCONFIRM: {
    url: "operationServiceAPI/CRPUSERCONFIRM",
    packageName: "",
  },
  GETCRPREQGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETCRPREQGRID",
    packageName: "",
  },
  VALIDATECRPNAME: {
    url: "operationServiceAPI/VALIDATECRPNAME",
    packageName: "",
  },
  GETCRPACCTDTLGRID: {
    url: "commonServiceAPI/GETDYNAMICDATA/GETCRPACCTDTLGRID",
    packageName: "",
  },
  GETCRPUSERDTLREQGRID: {
    url: "operationServiceAPI/GETCRPUSERDTLREQGRID",
    packageName: "",
  },
};

export const GetAPIURLFromAction = (action, pname) => {
  let UrlData = ActionWiseAPIConfiguration[action];
  let url = action;
  let PackageName = pname;
  if (Boolean(UrlData)) {
    if (Boolean(UrlData?.url)) {
      url = UrlData?.url;
    }
    PackageName = UrlData?.packageName ?? PackageName;
  }
  let apiurl = Boolean(PackageName)
    ? "./" +
      PackageName +
      (url.startsWith("./")
        ? url.substring(1)
        : url.startsWith("/")
        ? url
        : "/" + url)
    : url.startsWith(".")
    ? url
    : url.startsWith("/")
    ? "." + url
    : "./" + url;
  return apiurl;
};
